import { GenIcon } from '../helpers/IconBase.es.js';

const RightRoundedOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { transform: "translate(5.609 3.333)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M4.1972 3.25386L1.1372 0.193862C1.01229 0.0696944 0.843323 0 0.667199 0C0.491075 0 0.322107 0.0696944 0.197199 0.193862C0.134713 0.255837 0.0851172 0.329571 0.0512714 0.410811C0.0174257 0.49205 0 0.579187 0 0.667195C0 0.755203 0.0174257 0.84234 0.0512714 0.92358C0.0851172 1.00482 0.134713 1.07855 0.197199 1.14053L3.26387 4.19386C3.32635 4.25584 3.37595 4.32957 3.40979 4.41081C3.44364 4.49205 3.46107 4.57919 3.46107 4.6672C3.46107 4.7552 3.44364 4.84234 3.40979 4.92358C3.37595 5.00482 3.32635 5.07855 3.26387 5.14053L0.197199 8.19386C0.0716631 8.31852 0.00078661 8.48793 0.000161489 8.66484C-0.000463632 8.84175 0.0692144 9.01166 0.193866 9.1372C0.318518 9.26273 0.487933 9.33361 0.664842 9.33423C0.841751 9.33486 1.01166 9.26518 1.1372 9.14053L4.1972 6.08053C4.57173 5.70553 4.78211 5.1972 4.78211 4.6672C4.78211 4.13719 4.57173 3.62886 4.1972 3.25386V3.25386Z",
              fill: "#43464C"
            }
          }
        ]
      }
    ]
  })(props);
};

export { RightRoundedOutlined };
